import React from "react"

import { Link } from "gatsby"

import { Star } from "akar-icons"
import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./SummerCollections.scss"

const SummerCollections = ({ section }) => {
  return (
    <section className="summer-collections">
      <Fade>
        <div className="summer-collections__title">
          <p className="summer-collections__title__header">
            {section.title || "Lorem Ipsum"}
          </p>
          <p className="summer-collections__title__text">
            {section.description ||
              "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
          </p>
        </div>
        <div className="summer-collections__image">
          <div className="summer-collections__image__first">
            <img src={section.image1?.url} alt={section.image1?.alt} />
            <div className="summer-collections__image__first__overlay">
              <div className="summer-collections__image__first__overlay__upper">
                <p>{section.productName1 || "Lorem Ipsum"}</p>
                <p>
                  <Star strokeWidth={4} size={16} color="var(--color-orange)" />
                  &nbsp;
                  {section.productRating1 || "4.5"}
                </p>
              </div>
              <div clasName="summer-collections__image__first__overlay__price">
                <p className="summer-collections__image__first__overlay__lower__text">
                  Rs. {section.productSellingPrice1 || "1999"}
                  <span>Rs. {section.productMRP1 || "2999"}</span>
                </p>
                <button className="summer-collections__image__first__overlay__lower__btn">
                  <Link to={`/${section.cardbuttonLink}`}>
                    {section.cardbuttonText || "Lorem Ipsum"}&nbsp;
                  </Link>
                </button>
              </div>
            </div>
          </div>
          <div className="summer-collections__image__second">
            <img src={section.image2?.url} alt={section.image2?.alt} />
            <div className="summer-collections__image__second__overlay">
              <div className="summer-collections__image__second__overlay__upper">
                <p>{section.productName2 || "Lorem Ipsum"}</p>
                <p>
                  <Star strokeWidth={4} size={16} color="var(--color-orange)" />
                  &nbsp;
                  {section.productRating2 || "4.5"}
                </p>
              </div>
              <div className="summer-collections__image__second__overlay__lower">
                <p className="summer-collections__image__second__overlay__lower__text">
                  Rs. {section.productSellingPrice2 || "1999"}{" "}
                  <span>Rs. {section.productMRP2 || "2999"}</span>
                </p>
                <button className="summer-collections__image__second__overlay__lower__btn">
                  <Link to={`/${section.cardbuttonLink}`}>
                    {section.cardbuttonText || "Lorem Ipsum"}&nbsp;
                  </Link>
                </button>
              </div>
            </div>
          </div>
          <div className="summer-collections__image__third">
            <img src={section.image3?.url} alt={section.image3?.alt} />
            <div className="summer-collections__image__third__overlay">
              <div className="summer-collections__image__third__overlay__upper">
                <p>{section.productName3 || "Lorem Ipsum"}</p>
                <p>
                  <Star strokeWidth={4} size={16} color="var(--color-orange)" />{" "}
                  &nbsp;
                  {section.productRating3 || "4.5"}
                </p>
              </div>
              <div className="summer-collections__image__third__overlay__lower">
                <p className="summer-collections__image__third__overlay__lower__text">
                  Rs. {section.productSellingPrice3 || "1999"}{" "}
                  <span>Rs. {section.productMRP3 || "2999"}</span>
                </p>
                <button className="summer-collections__image__third__overlay__lower__btn">
                  <Link to={`/${section.cardbuttonLink}`}>
                    {section.cardbuttonText || "Lorem Ipsum"}&nbsp;
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="summer-collections__bottom">
          <button>
            <Link to={`/${section.bottomButtonLink}`}>
              {section.bottomButtonText || "Lorem Ipsum"}&nbsp;
            </Link>
          </button>
        </div>
      </Fade>
    </section>
  )
}

SummerCollections.propTypes = {
  section: PropTypes.object.isRequired,
}

export default SummerCollections
